import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import backbluebtn from "../../../../../Utils/Images/backbluebtn.png";
import gallary from "../../../../../Utils/Images/Gallerywhite.png";
import { GetSingleVoucher } from "../../../../../APIs/Function/Voucher/GetSingleVoucher";
import CustomButton from "../../../../../Components/Button/CustomButton";
import CustomInput from "../../../../../Components/input/CustomInput";
import { handleUpdateVoucher } from "../../../../../APIs/Function/Voucher/EditVoucher";

const EditVoucher = () => {
  const { id } = useParams();
  const [previewImage, setPreviewImage] = useState([]);
  const [singleVoucher, setSingleVoucher] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const Arr = [
    {
      key: "10",
      value: "10",
    },
    {
      key: "20",
      value: "20",
    },
    {
      key: "30",
      value: "30",
    },
  ];
  const Arr2 = [
    {
      key: "100",
      value: "100",
    },
    {
      key: "200",
      value: "200",
    },
    {
      key: "300",
      value: "300",
    },
  ];
  const handleEditVoucher = async () => {
    try {
      let res = await GetSingleVoucher(id);
      setSingleVoucher(res.r);
      setFormData({
        ...formData,
        name: res.r.name,
        description: res.r.description,
        link: res.r.link,
        code: res.r.code,
        image: res.r.image,
        discount_type: res.r.discount_type,
        discount_value: res.r.discount_value,
        voucher_type: res.r.voucher_type,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const initialFormData = {
    name: "",
    description: "",
    link: "",
    code: "",
    image: "",
    voucher_type: "",
    discount_type: "",
    discount_value: null,
  };

  const [formData, setFormData] = useState(initialFormData);
  const discountValueOptions =
    formData.discount_type === "2"
      ? ["100", "200", "300"]
      : formData.discount_type === "1"
      ? ["10", "20", "30"]
      : [];

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      formData.code.trim() !== "" &&
      formData.description.trim() !== "" &&
      formData.image &&
      formData.link.trim() !== "" &&
      formData.name.trim() !== ""
    ) {
      try {
        setLoading(true);
        await handleUpdateVoucher({ id, ...formData });
        setLoading(false);
        alert("Data Edited Successfully");
        navigate("/voucher");
      } catch (error) {
        console.log(error);
      }
    } else {
      alert("Please Fill All Details");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const image = event.target.files[0];
    setFormData({
      ...formData,
      image: image,
    });
  };

  useEffect(() => {
    // Update formData's image property whenever previewImage changes
    const updatedFormData = {
      ...formData,
      image: previewImage,
    };
    setFormData(updatedFormData);
    handleEditVoucher();
  }, [previewImage]);

  console.log(singleVoucher)
  return (
    <>
      {/* header */}
      <Box
        sx={{
          bgcolor: "#31AEF4",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: { xs: "50px", md: "70px", lg: "70px" },
          p: "10px",
          boxSizing: "border-box",
        }}
      >
        <Link to={`/voucher`}>
          <Box
            sx={{
              height: { xs: "50px", md: "60px", lg: "60px" },
              display: "flex",
              alignItems: "center",
            }}
          >
            <img height={"100%"} src={backbluebtn} alt="back" />
          </Box>
        </Link>
        <Box>
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontSize: { md: "30px", sm: "20px" },
              fontWeight: 600,
              lineHeight: "36px",
              color: "#FFFFFF",
            }}
          >
            Edit Voucher
          </Typography>
        </Box>
        <Box>
          <CustomButton
            onClick={handleSubmit}
            sx={{
              width: { xs: "40px", md: "50px", lg: "80px" },
              height: { xs: "10px", md: "50px", lg: "50px " },
            }}
          >
            {loading ? <CircularProgress></CircularProgress> : "Save"}
          </CustomButton>
        </Box>
      </Box>
      <Box
        sx={{
          p: 2,
          boxSizing: "border-box",
          display: "flex",
          justifyContent: "center ",
        }}
      >
        {/* Form */}
        <Box
          sx={{
            mt: "10px",
            border: "1px solid #E8E8E8",
            width: "45%",
            boxSizing: "border-box",
            p: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between ",
              alignItems: "center",
              boxSizing: "border-box",
              p: 1,
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontFamily: "inter",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "20px",
                }}
              >
                Gallary
              </Typography>
            </Box>
            <Box>
              <label htmlFor="file-input">
                <Box
                  sx={{
                    display: "flex",
                    bgcolor: "#000000",
                    height: "50px",
                    width: "100%",
                    gap: "5px ",
                    alignItems: "center",
                    borderRadius: "5px",
                    p: 2,
                    boxSizing: "border-box",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#FFFFFF",
                      fontFamily: "inter",
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "16px",
                    }}
                  >
                    Upload Image
                  </Typography>
                  <Box sx={{ width: "25px", height: "25px" }}>
                    <img width={"100%"} src={gallary} alt="gallary" />
                  </Box>
                </Box>
              </label>
              <input
                accept="image/*"
                type="file"
                id="file-input"
                multiple
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            <Box sx={{ width: "30%", height: "200px" }}>
              {singleVoucher.image && (
                <img
                  style={{ borderRadius: "10px" }}
                  width={"100%"}
                  height={"100%"}
                  src={`https://api.qhealth.com.au/upload/images/${singleVoucher.image}`}
                  alt="preview"
                />
              )}
            </Box>
          </Box>
        </Box>
        <Box sx={{ width: "45%" }}>
          <Container maxWidth="sm" sx={{ mt: "10px" }}>
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CustomInput
                    label="Voucher Name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label="Description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    fullWidth
                    multiline
                    rows={4}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label="Code"
                    name="code"
                    value={formData.code}
                    onChange={handleInputChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label="Link"
                    name="link"
                    value={formData.link}
                    onChange={handleInputChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} sx={{ mt: "15px" }}>
                  <FormControl fullWidth required>
                    <InputLabel
                      sx={{
                        backgroundColor: "#FFF",
                      }}
                    >
                      Voucher Type
                    </InputLabel>
                    <Select
                      name="voucher_type"
                      value={formData.voucher_type}
                      onChange={handleInputChange}
                      sx={{ textAlign: "left" }}
                    >
                      <MenuItem value="1">For Product</MenuItem>
                      <MenuItem value="2">For Plan</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sx={{ mt: "15px" }}>
                  <FormControl fullWidth required>
                    <InputLabel
                      sx={{
                        backgroundColor: "#FFF",
                      }}
                    >
                      Discount Type
                    </InputLabel>
                    <Select
                      name="discount_type"
                      value={formData.discount_type}
                      onChange={handleInputChange}
                      sx={{ textAlign: "left" }}
                    >
                      <MenuItem value="1">Percentage</MenuItem>
                      <MenuItem value="2">Price</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {formData.discount_type && ( // Conditional rendering of discount_value field
                      <Grid item xs={12} sx={{ mt: "15px" }}>
                        <FormControl fullWidth required>
                          <InputLabel
                            sx={{
                              bgcolor: "#fff",
                            }}
                          >
                            Discount Value
                          </InputLabel>
                          <Select
                            name="discount_value"
                            value={formData.discount_value}
                            onChange={handleInputChange}
                            sx={{ textAlign: "left" }}
                          >
                            {formData.discount_type == "1"
                              ? Arr.map((option, index) => (
                                  <MenuItem key={index} value={option.value}>
                                    {option.key}
                                  </MenuItem>
                                ))
                              : Arr2.map((option, index) => (
                                  <MenuItem key={index} value={option.value}>
                                    {option.key}
                                  </MenuItem>
                                ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}
              </Grid>
            </form>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default EditVoucher;
